<template>
	<!--
---- TEMPORARY FOR QA TESTING -- NEEDS DISCUSSION AND WORK BEFORE PRODUCTION RELEASE
-->
	<div class="error-notification" v-if="showError">
		<NotificationBlock
			state="warning"
			iconClassName="icon-warning"
			:expanded="expanded"
			:title="errorMessage"
		>
			<div>
				<div>{{ errorDetails }}</div>
			</div>
			<template v-slot:btnSlot>
				<ButtonClassic
					@click="onClearError"
					variant="primary"
					labelText="Close"
				/>
			</template>
		</NotificationBlock>
	</div>
</template>

<script>
import NotificationBlock from '@/components/notifications/notification-block/notification-block.vue';
import { mapGetters, mapActions } from 'vuex';
import ButtonClassic from '@/components/forms/button/button-classic.vue';

export default {
	name: 'ErrorNotifications',
	data() {
		return {
			expanded: true
		};
	},
	components: {
		NotificationBlock,
		ButtonClassic
	},
	computed: {
		...mapGetters('app', ['currentError']),
		showError() {
			let result = false;
			let publicRoute = false;

			if (this.$route.meta && !this.$route.meta.isPublic) {
				publicRoute = true;
			}

			if (this.currentError && publicRoute) {
				result = true;
			}

			return result;
		},
		errorMessage() {
			let message;

			if (this.currentError && this.currentError.message) {
				message = this.currentError.message;
			}

			return message;
		},
		errorDetails() {
			let details;

			if (
				this.currentError &&
				this.currentError.response &&
				this.currentError.response.data
			) {
				details = JSON.stringify(this.currentError.response.data);
			}

			return details;
		}
	},
	methods: {
		...mapActions('app', ['clearCurrentErrorAction']),
		onClearError() {
			this.clearCurrentErrorAction();
		}
	}
};
</script>

<style lang="scss" scoped>
/*****
**** TEMPORARY FOR QA TESTING -- NEEDS DISCUSSION AND WORK BEFORE PRODUCTION RELEASE
*****/
.error-notification {
	position: relative;
	@include page-content-padding;
	margin-bottom: $gutter-lg;

	.has-action-bar & {
		position: relative;
		top: 70px; // Action Ribbon height.
	}
}
</style>
